import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=ca099a6c&scoped=true"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"
import style0 from "./Challenges.vue?vue&type=style&index=0&id=ca099a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca099a6c",
  null
  
)

export default component.exports